import EmailIcon from '@mui/icons-material/Email';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { ShareButtonBase } from './ShareButtonBase';
import { getFullURL } from './shareUtils';

export const EmailButton = ({ url, title, text, sharedItemName, shareOrigin, ...rest }) => {
  const intl = useIntl();
  const shareUrl = url || getFullURL();
  const subject = encodeURIComponent(title);
  const body = encodeURIComponent(text ? `${text}\n\n${shareUrl}` : shareUrl);

  const handleShare = () => {
    const mailtoUrl = `mailto:?subject=${subject}&body=${body}`;
    window.location.href = mailtoUrl;
  };

  return (
    <ShareButtonBase
      icon={<EmailIcon />}
      label={intl.formatMessage({ id: 'ShareActions.email', defaultMessage: 'Email' })}
      url={shareUrl}
      sharedItemName={sharedItemName}
      shareOrigin={shareOrigin}
      onClick={handleShare}
      title={title}
      text={text}
      {...rest}
    />
  );
};

EmailButton.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
};

EmailButton.defaultProps = {
  url: '',
  title: 'Check this out',
  text: '',
};
